import { useGLTF } from "@react-three/drei";
import { forwardRef } from "react";
import useSetMaterial from "../utils/useSetMaterial";

//region SingleCasementWindow
export function BuildingExterior({
}) {
  const { nodes, materials } = useGLTF("/models/building_exterior.glb");

//   console.log("nodes", nodes);
//   console.log("materials", materials);

  function setRotation(x,y,z){
    return [(Math.PI/180)*x, (Math.PI/180)*y, (Math.PI/180)*z]
  }

  useSetMaterial(materials.Bricks, "Bricks")
  useSetMaterial(materials.Concrete1, "Concrete1")
  useSetMaterial(materials.Concrete2, "Concrete2")
  useSetMaterial(materials.Concrete3, "Concrete3")
  useSetMaterial(materials.body_paint, "white paint")
  useSetMaterial(materials.glass, "glass")
  useSetMaterial(materials.Roof, "Roof")
  useSetMaterial(materials.innerWall, "InnerWall");

  return (
    <group
      dispose={null}
      position={[0,0,-0.15]}
    //   scale={activeHinge === 1 ? [1, 1, 1] : [-1, 1, 1]}
    rotation={setRotation(0,0,0)}
    >
    <mesh
    castShadow
      receiveShadow
      geometry={nodes.building_exterior_1.geometry}
    //   material={materials.Asphalt02}
      material={materials.Bricks}
    />
    <mesh
    castShadow
      receiveShadow
      geometry={nodes.building_exterior_5.geometry}
    //   material={materials.Block04}
        material={materials.Roof}
    />
    <mesh
    castShadow
      receiveShadow
      geometry={nodes.building_exterior_4.geometry}
    //   material={materials.Brick07}
      material={materials.Concrete3}
    />
    <mesh
    castShadow
      receiveShadow
      geometry={nodes.building_exterior_2.geometry}
      material={materials.Concrete1}
    />
    <mesh
    castShadow
      receiveShadow
      geometry={nodes.building_exterior_3.geometry}
      material={materials.Concrete2}
    />
    <mesh
    castShadow
      receiveShadow
      geometry={nodes.building_exterior_6.geometry}
      material={materials.body_paint}
    />
    <mesh
    castShadow
      receiveShadow
      geometry={nodes.building_exterior_7.geometry}
      material={materials.glass}
    />
    <mesh
    castShadow
      receiveShadow
      geometry={nodes.building_exterior_8.geometry}
      material={materials.innerWall}
    />
    {/* <mesh
    castShadow
      receiveShadow
      geometry={nodes.building_exterior.geometry}
      material={materials.Brick07}
    /> */}
    </group>
  );
}

useGLTF.preload("/models/building_exterior.glb");
